// firebase.js (or another name you prefer)
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_GOOGLE_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_GOOGLE_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_GOOGLE_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_GOOGLE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_GOOGLE_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_GOOGLE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database };
